import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { fi } from "date-fns/locale/fi";

const DateInput = (props) => {
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    if (props.value) {
      setSelectedDate(new Date(props.value));
    }
  }, [props.value]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    props.updateValues({ [props.name]: date });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fi}>
      <Grid container sx={{ justifyContent: "space-around" }}>
        <DatePicker
          label={props.label}
          value={selectedDate || null}
          onChange={handleDateChange}
          format="dd.MM.yyyy"
          slotProps={{
            textField: {
              fullWidth: true,
              margin: "dense",
              id: props.id || "date_input",
            },
            actionBar: {
              actions: ["cancel", "accept"],
            },
          }}
          localeText={{
            cancelButtonLabel: t("Peruuta"),
            okButtonLabel: t("OK"),
          }}
        />
      </Grid>
    </LocalizationProvider>
  );
};

export default DateInput;
